export const personalTeamSelector = state => state.personalTeam;
